module.exports = __webpack_public_path__ + "img/city1.160b9360.png";